var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":_vm.$t('lostConnectionModalTitle')},on:{"close-modal":function($event){return _vm.$emit('close-modal', false)}}},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t("lostConnectionModalDescription")))])])}
var staticRenderFns = []

export { render, staticRenderFns }